import WebFont from "webfontloader";
import { DebugHelper } from "@/helper/debugHelper";

export class FontHelper
{
    public static loadWebFonts(completion : () => void, error : () => void)
    {
        // CAUTION DesignRendererと一致させる
        WebFont.load({
            google : {
                families : [
                    "Kosugi:japanese",
                    "Kosugi Maru:japanese",
                    "M PLUS 1p:100,300,400,500,700,800,900:japanese,latin-ext",
                    "M PLUS Rounded 1c:100,300,400,500,700,800,900:japanese,latin-ext",
                    "Noto Sans JP:100,300,400,500,700,900:japanese",
                    "Noto Serif JP:200,300,400,500,600,700,900:japanese",
                    "Sawarabi Gothic:japanese,latin-ext",
                    "Sawarabi Mincho:japanese,latin-ext",
                    "Abril Fatface",
                    "Amatic SC:400,700:cyrillic,hebrew,latin-ext,vietnamese",
                    "Covered By Your Grace",
                    "Great Vibes",
                    "Indie Flower",
                    "Lato:300,300i,400,400i,900,900i:latin-ext",
                    "Lobster:cyrillic,cyrillic-ext,latin-ext,vietnamese",
                    "Lobster Two:400,400i,700,700i",
                    "Lora:400,400i,700,700i:cyrillic,cyrillic-ext,latin-ext",
                    "Merriweather:400,400i,900,900i:cyrillic,cyrillic-ext,latin-ext",
                    "Monoton",
                    "Montserrat:200,200i,400,400i,600,600i,800,800i:cyrillic,cyrillic-ext,latin-ext,vietnamese",
                    "Oswald:200,300,400,500,600,700:cyrillic,latin-ext,vietnamese",
                    "Playfair Display:400,400i,700,700i,900,900i:cyrillic,latin-ext,vietnamese",
                    "Raleway:200,200i,400,400i,600,600i,800,800i:latin-ext",
                    "Slabo 27px",
                    "Open Sans:300,300i,400,400i,600,600i,700,700i,800,800i:latin-ext",
                    "Lusitana:400,700",
                    "Anton:latin-ext,vietnamese",
                    "McLaren",
                    "Fira Sans:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i:cyrillic,cyrillic-ext,greek,greek-ext,latin-ext,vietnamese",
                    "Cutive",
                    "Cutive Mono",
                    "Vollkorn:400,400i,600,600i,700,700i,900,900i:cyrillic,cyrillic-ext,greek,latin-ext,vietnamese",
                    "Muli:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i:latin-ext,vietnamese",
                    "Open Sans Condensed:300,300i,700:cyrillic,cyrillic-ext,greek,greek-ext,latin-ext,vietnamese",
                    "Cardo:400,400i,700:greek,greek-ext,latin-ext",
                    "Work Sans:100,200,300,400,500,600,700,800,900:latin-ext",
                    // 多言語
                    "Noto Sans:400,400i,700,700i:cyrillic,cyrillic-ext,devanagari,greek,greek-ext,latin-ext,vietnamese",
                    "Noto Sans SC:100,300,400,500,700,900:chinese-simplified,cyrillic,japanese,vietnamese",
                    "Noto Sans KR:100,300,400,500,700,900:korean",
                    "Noto Serif:400,400i,700,700i:cyrillic,cyrillic-ext,greek,greek-ext,latin-ext,vietnamese",
                    "Noto Serif SC:200,300,400,500,600,700,900:chinese-simplified,cyrillic,japanese,vietnamese",
                    "Noto Serif KR:200,300,400,500,600,700,900:korean"
                ]
            },
            loading : () =>
            {
                DebugHelper.trace("font is loading...");
            },
            active : () =>
            {
                DebugHelper.trace("font is loaded completely.");
                completion();
            },
            inactive : () =>
            {
                DebugHelper.trace("font is not loaded.");
                error();
            }
        });
    }
}
